import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "caass-demographics-current-block-list-table",
	templateUrl: "./demographics-current-block-list-table.component.html",
	styleUrls: ["./demographics-current-block-list-table.component.css"],
})
export class DemographicsCurrentBlockListTableComponent implements OnInit {
	constructor() {}
	ngOnInit(): void {}

	//////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////

	@Input() lstBlockList: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	SelectedStationBlockAlert: any;
	//Filter Lists
	lstAddedByDesc: any = [];
	lstActiveDesc: any = [];

	cols: any = [
		{ field: "Message", header: "Message" },
		{ field: "AddedByDesc", header: "Added By" },
		{ field: "DateDesc", header: "Date Range" },
		{ field: "TimeDesc", header: "Time Range" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	loading: boolean = false;

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////

	onRowSelect(val) {
		this.SelectedStationBlockAlert = val.data;
	}
	onRowUnselect(val) {
		this.SelectedStationBlockAlert = null;
	}

	//////////////////////////////////////////////////////////////
}
